// Module Reducer
import {
  GET_MODULES,
  GET_MODULES_SUCCESS,
  GET_MODULES_FAIL,
  GET_MODULES_RESET,
  GET_MODULE_BY_ID,
  GET_MODULE_BY_ID_SUCCESS,
  GET_MODULE_BY_ID_FAIL,
  GET_MODULE_BY_ID_RESET,
  CREATE_MODULE,
  CREATE_MODULE_SUCCESS,
  CREATE_MODULE_FAIL,
  CREATE_MODULE_RESET,
  UPDATE_MODULE,
  UPDATE_MODULE_SUCCESS,
  UPDATE_MODULE_FAIL,
  UPDATE_MODULE_RESET,
  DELETE_MODULE,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_FAIL,
  DELETE_MODULE_RESET,
  GET_SUB_MODULES,
  GET_SUB_MODULES_SUCCESS,
  GET_SUB_MODULES_FAIL,
  GET_SUB_MODULES_RESET,
  GET_MODULES_DROPDOWN,
  GET_MODULES_DROPDOWN_SUCCESS,
  GET_MODULES_DROPDOWN_FAIL,
  GET_MODULES_DROPDOWN_RESET,
} from '../actions/moduleAction';

const initialState = {
  getModulesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getModuleByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createModuleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateModuleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteModuleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getSubModulesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getModulesDropdownState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MODULES:
      return {
        ...state,
        getModulesState: { ...state.getModulesState, apiState: 'loading' },
      };
    case GET_MODULES_SUCCESS:
      return {
        ...state,
        getModulesState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Modules retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_MODULES_FAIL:
      return {
        ...state,
        getModulesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch modules',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_MODULES_RESET:
      return {
        ...state,
        getModulesState: initialState.getModulesState,
      };

    case GET_MODULE_BY_ID:
      return {
        ...state,
        getModuleByIdState: { ...state.getModuleByIdState, apiState: 'loading' },
      };
    case GET_MODULE_BY_ID_SUCCESS:
      return {
        ...state,
        getModuleByIdState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Module retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_MODULE_BY_ID_FAIL:
      return {
        ...state,
        getModuleByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch module',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_MODULE_BY_ID_RESET:
      return {
        ...state,
        getModuleByIdState: initialState.getModuleByIdState,
      };

    case CREATE_MODULE:
      return {
        ...state,
        createModuleState: { ...state.createModuleState, apiState: 'loading' },
      };
    case CREATE_MODULE_SUCCESS:
      return {
        ...state,
        createModuleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Module created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_MODULE_FAIL:
      return {
        ...state,
        createModuleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create module',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_MODULE_RESET:
      return {
        ...state,
        createModuleState: initialState.createModuleState,
      };

    case UPDATE_MODULE:
      return {
        ...state,
        updateModuleState: { ...state.updateModuleState, apiState: 'loading' },
      };
    case UPDATE_MODULE_SUCCESS:
      return {
        ...state,
        updateModuleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Module updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_MODULE_FAIL:
      return {
        ...state,
        updateModuleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update module',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_MODULE_RESET:
      return {
        ...state,
        updateModuleState: initialState.updateModuleState,
      };

    case DELETE_MODULE:
      return {
        ...state,
        deleteModuleState: { ...state.deleteModuleState, apiState: 'loading' },
      };
    case DELETE_MODULE_SUCCESS:
      return {
        ...state,
        deleteModuleState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Module deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_MODULE_FAIL:
      return {
        ...state,
        deleteModuleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete module',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_MODULE_RESET:
      return {
        ...state,
        deleteModuleState: initialState.deleteModuleState,
      };

    case GET_SUB_MODULES:
      return {
        ...state,
        getSubModulesState: { ...state.getSubModulesState, apiState: 'loading' },
      };
    case GET_SUB_MODULES_SUCCESS:
      return {
        ...state,
        getSubModulesState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Sub-modules retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_SUB_MODULES_FAIL:
      return {
        ...state,
        getSubModulesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch sub-modules',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_SUB_MODULES_RESET:
      return {
        ...state,
        getSubModulesState: initialState.getSubModulesState,
      };

    case GET_MODULES_DROPDOWN:
      return {
        ...state,
        getModulesDropdownState: { ...state.getModulesDropdownState, apiState: 'loading' },
      };
    case GET_MODULES_DROPDOWN_SUCCESS:
      return {
        ...state,
        getModulesDropdownState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Modules retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_MODULES_DROPDOWN_FAIL:
      return {
        ...state,
        getModulesDropdownState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch modules',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_MODULES_DROPDOWN_RESET:
      return {
        ...state,
        getModulesDropdownState: initialState.getModulesDropdownState,
      };

    default:
      return state;
  }
};

export default moduleReducer;

